import { h, Component } from 'preact';
import { IBaseFieldProps, IBaseFieldState } from './IBaseField';
import { BaseComponent } from "../../../common/BaseComponent";


export abstract class BaseField<TProp extends IBaseFieldProps, TState extends IBaseFieldState> extends BaseComponent<TProp, TState> { 
    public getValue() {
        return this.state.value;
    }
}


// WEBPACK FOOTER //
// ./components/forms/fields/BaseField.ts